module.exports = __webpack_public_path__ + "static/media/4.e231fedb.gif";